export const isValidAlert = (row) => row.type === "alert" && row.title;

export const isValidQuestion = (row) =>
  row.type === "question" && row.input_type;

export const isValidRecursiveQuestion = (row, context = {}) => {
  const { responses } = context;
  const isRecursive = row.type === "recursive_question";

  if (responses) {
    return isRecursive && responses?.[row.id]?.recursive_question_value;
  }
  return isRecursive;
};

export const isValidOutput = (row) => row.type === "output" && row.output_type;
